const iterableDivision = 'Brand';
const iterableBrand = 'Penguin Newsletter';
const iterableApiUrl = 'https://www.penguin.co.uk/api/forms/shop-newsletter';
const iterableFormName = 'Penguin Newsletter';
const inputErrorClassArray = ['newsletter-email--error', 'has-error'];

const getIterableSuccess = (formNode) => {
	if (formNode.classList.contains('popup__signupForm')) {
		document.cookie = `popupShown=true; path=/; max-age=${60 * 60 * 24 * 14};`;
	}
    const successEvent = new CustomEvent('form-success');
    document.dispatchEvent(successEvent);
    // Update UI.
    const nodeNotice = formNode.querySelector('.iterableForm__notice');
    nodeNotice.innerHTML = 'Thank you for signing up to the Penguin newsletter.';
    formNode.classList.add('signup--complete');
}

const getIterableFail = (formNode) => {
    node.classList.add('signup--error');
    const nodeNotice = formNode.querySelector('.iterableForm__notice');
    nodeNotice.innerHTML = 'There was an error submitting the form. Please try again later.';
    formNode.classList.add('signup--complete');
}

const sendIterableForm = async (signupData, formNode) => {
  const query = {
    method: 'POST',
    body: new URLSearchParams({
      ...signupData,
    }),
  };

  const response = await fetch(iterableApiUrl, query);
  const data = await response.json();
  if (data.success) {
  	getIterableSuccess(formNode);
  } else {
  	getIterableFail(formNode);
  }
}

const validateIterableEmail = (input) => {
	const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return regex.test(String(input).toLowerCase());	
}

window.addEventListener('load', function(event) {
	const iterableFormNodes = document.querySelectorAll('.newsletter-form, .popup__signupForm');
	iterableFormNodes.forEach((node) => {
		const emailInput = node.querySelector('input[type="email"]');
		node.addEventListener('submit', (event) => {
			event.preventDefault();
			if (validateIterableEmail(emailInput?.value)) {
				emailInput.classList.remove(...inputErrorClassArray);

				const signupData = {
					iterableDivision,
					iterableBrand,
					formName: iterableFormName,
					email: emailInput?.value,
				};

				return sendIterableForm(signupData, node);
			} else {
				emailInput.classList.add(...inputErrorClassArray);
                emailInput.classList.add('test');
                const errorEvent = new CustomEvent('form-error');
                document.dispatchEvent(errorEvent);
			}
		});
	});
});